import { Component } from 'solid-js'

const HuanYouAISettings: Component = () => {
  return (
    <>
      <div class="text-xl">HuanYouAI Text To Speech</div>
    </>
  )
}

export default HuanYouAISettings
